export const JSON_ONE43 = {
   
  
    
        "ag_id": "paygate",
        "me_id": "202104210302",
        "request_type": "Create Virtual Account",
        "channel": null,
        "me_order_id": "78sdsd61340031",
        "pg_id": 615,
        "paymode": null,
        "scheme": null,
        "cust_name": "Rutuja",
        "cust_email_id": "abcz@safexpay.com",
        "cust_mobile_no": "7887936877",
        "cust_ref_num": null,
        "cust_account_number": "5323445678136109",
        "cust_ifsc_code": null,
        "cust_bank_Name": null,
        "cust_bankbranch_name": null,
        "cust_bankcity_name": null
        }

